function Footer() {
  return (
<footer id="contact">
          <p>© 2026 Meo.Mart </p>
    </footer>
  );
}

export default Footer;